import { TournamentsCacheKey } from './constants'

export function getTournamentsCacheKey(...rest: string[]) {
  return [TournamentsCacheKey, ...rest]
}
